const { Parser } = require('json2csv');

export default {
    export: (data, fields, fileName) => {
        try {
            const json2csvParser = new Parser({ fields });
            const result = json2csvParser.parse(data);
            var BOM = "\uFEFF";
            var header = "data:text/csv;charset=utf-8,";            
            var blob = new Blob([ BOM + result ], {type: header});
            var href = URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.setAttribute("href", href);
            link.setAttribute("download", `${(fileName || 'file')}.csv`);
            document.body.appendChild(link); // Required for FF
            link.click(); // This will download the data file
            document.body.removeChild(link); // Required for FF
      
        } catch (err) {
            // Errors are thrown for bad options, or if the data is empty and no fields are provided. 
            // Be sure to provide fields if it is possible that your data array will be empty. 
            console.error(err);
        }
    }
}
